import { render, staticRenderFns } from "./LargePay.vue?vue&type=template&id=72154cd8&scoped=true&"
import script from "./LargePay.vue?vue&type=script&lang=js&"
export * from "./LargePay.vue?vue&type=script&lang=js&"
import style0 from "./LargePay.vue?vue&type=style&index=0&id=72154cd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72154cd8",
  null
  
)

export default component.exports